// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const BirthdatePhase = {
  "BEFORE": "BEFORE",
  "AFTER": "AFTER"
};

const { Tenant, District, Info, Checklist, ChecklistItem, UserCheckedChecklistItem, UserHiddenChecklistItem, ChecklistMedia, Media, Page, UserSettings, Locale, ChecklistItemDate, ChecklistItemContentList, ChecklistItemContentDetail, BirthdateSettings } = initSchema(schema);

export {
  Tenant,
  District,
  Info,
  Checklist,
  ChecklistItem,
  UserCheckedChecklistItem,
  UserHiddenChecklistItem,
  ChecklistMedia,
  Media,
  Page,
  UserSettings,
  BirthdatePhase,
  Locale,
  ChecklistItemDate,
  ChecklistItemContentList,
  ChecklistItemContentDetail,
  BirthdateSettings
};